import React from 'react'
import config from '../../../config'

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='container'>
        <div className='content has-text-centered'>
          <p>
            {config.copyright}
          </p>
          {/* <p>Powered by <a href='https://www.gatsbyjs.org'>Gatsby</a> */}
          {/* and */}
          {/* <a href='https://www.netlifycms.org'>Netlify CMS</a> */}
          {/* <p><a href='https://pait.pl'>Hosting & Services - pait.pl</a></p> */}
        </div>
      </div>
    </footer>
  )
}

export default Footer
